exports.run = store => {
    const initializers = [
        require("./auth-token"),
        require("./fetch-data"),
        require("./persist"),
        require("./google-analytics")
    ];

    initializers.forEach(init => init(store));
};



// WEBPACK FOOTER //
// ./src/initializers/index.js